import { ActivityLogTab } from "@features/ax/shared/ActivityLog";
import { NotesTab } from "@features/ax/shared/NotesTab";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import { useParams } from "react-router-dom";
import { AlertsLanding } from "./alerts/landing";
import AssetsTab from "./asset/asset";
import { ComplianceLanding } from "./compliance/landing";
import { ConditionAndRiskLanding } from "./conditionAndRisk/landing";
import { NetworkFilesTab } from "./files/files";
import { NetworkFinanceTab } from "./NetworkFinanceTab/NetworkFinanceTabs";
import { NetworkPerformanceTab } from "./NetworkPerformanceTab/NetworkPerformanceTab";
import { ScheduleLanding } from "./NetworkSchedulesTab/NetworkSchedulesTab";
import { NetworkServiceOrdersTab } from "./NetworkServiceOrdersTab/NetworkServiceOrdersTab";

interface NetworkTabsProps {
  networkData?: any;
  data?: any;
}

export const NetworkTabs: React.FC<NetworkTabsProps> = ({
  networkData,
  data,
}) => {
  const { id } = useParams();
  const source = "5";
  // Tab configuration object for the shared tabs service
  const tabComponents = {
    performance: {
      label: "Overview",
      component: <NetworkPerformanceTab />,
      shortLabel: "Overview",
    },
    alerts: {
      label: "Alerts",
      component: <AlertsLanding />,
      shortLabel: "Alerts",
    },
    finance: {
      label: "Finance",
      component: <NetworkFinanceTab networkData={networkData} />,
      shortLabel: "Finance",
    },
    compliance: {
      label: "Compliance",
      component: <ComplianceLanding />,
      shortLabel: "Comply",
    },
    assets: {
      label: "Assets",
      component: <AssetsTab network={networkData} />,
      shortLabel: "Assets",
    },
    "conditions-risks": {
      label: "Conditions & Risks",
      component: <ConditionAndRiskLanding networkData={data} />,
      shortLabel: "Risks",
    },
    schedules: {
      label: "Schedules",
      component: <ScheduleLanding />,
      shortLabel: "Schedule",
    },

    "service-orders": {
      label: "O&M",
      component: <NetworkServiceOrdersTab networkData={networkData} />,
      shortLabel: "Orders",
    },
    files: {
      label: "Files & Documents",
      component: <NetworkFilesTab />,
      shortLabel: "Files",
    },
    notes: {
      label: "Notes",
      component: <NotesTab requestId={id} source={source} title="Network" />,
    },
    activity: {
      label: "Activity Log",
      component: <ActivityLogTab entityId={id} entityType={source} />,
      shortLabel: "Activity",
    },
  };

  // URL mapping for cleaner URLs (optional)
  const urlMapping = {
    performance: "performance",
    alerts: "alerts",
    finance: "finance",
    compliance: "compliance",
    "conditions-risks": "risks",
    schedules: "schedule",
    assets: "assets",
    "service-orders": "orders",
    files: "files",
    notes: "notes",
    activity: "activity",
  };

  return (
    <div className="w-full">
      <Tabs
        defaultValue="performance"
        tabComponents={tabComponents}
        urlMapping={urlMapping}
        tabsListClassName="grid w-full grid-cols-11 mb-6"
        tabsListFullWidth={true}
        idPrefix="network-tab"
        className="w-full"
      />
    </div>
  );
};
